module.exports = __webpack_public_path__ + "img/q2.a93a821d.png";